import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/pink.png";
import fruit from "/cywe-assets/fruit/dragon-fruit.png";

export default function Pink({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="He is temperate in all things!"
				description="Being able to confront yourself and stop when unnecessary action will harm yourself or another. When you go too far against what is appropriate behavior, in harming yourself or other people. Consciously controlling your emotions but not in a way that you bottle them up and it stops you from breathing. Always considering all the factors involved and finding the best solution that will work for both of you."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/8"
				next="/experience/results"
			/>
		</>
	);
}
